 /* AI Art Finder — loaded from the section via asset_url so browsers can cache it */
(function() {

  'use strict';

  function initArtFinder(root) {

  if (!root || root.getAttribute('data-aaf-ready')) return;

  root.setAttribute('data-aaf-ready', '1');

  var input = root.querySelector('.aaf-input');
  var button = root.querySelector('.aaf-button');
  var status = root.querySelector('.aaf-status');
  var results = root.querySelector('.aaf-results');
  var grid = root.querySelector('.aaf-grid');
  var empty = root.querySelector('.aaf-empty');
  var clear = root.querySelector('.aaf-clear');
  var examples = root.querySelectorAll('.aaf-example');
  var resultsTitle = root.querySelector('.aaf-results-title');
  var back = root.querySelector('.aaf-back');
  var moreWrap = root.querySelector('.aaf-more-wrap');
  var more = root.querySelector('.aaf-more');

  var defaultHeading = resultsTitle ? resultsTitle.textContent.trim() : '';

  /*
   * What the grid is showing: the full ranked list, how many
   * cards are visible, and the search to go back to after
   * "More like this".
   */

  var view = { cards: [], shown: 0, mode: 'search' };
  var savedSearch = null;
  var currentIndex = null;
  var lastQuery = '';
  var similarSource = null;

  var resultCount = parseInt(
    root.getAttribute('data-results') || '8',
    10
  );

  var apiEndpoint =
    root.getAttribute('data-api-endpoint') || '';

  var collectionHandle =
    root.getAttribute('data-collection-handle') || 'art-prints';

  var catalogueUrl = root.getAttribute('data-catalogue-url') || 'https://cdn.shopify.com/s/files/1/0689/8109/files/glenn-art-finder-catalogue.json';


  /* =========================================================
     HOW THIS SEARCH WORKS

     1. The visual catalogue (AI-tagged subject, colours, hex
        palette, mood, rooms, style…) is merged with the live
        Shopify collection feed (tags + description) by handle.

     2. Every field is tokenised and lightly stemmed
        ("tuis" -> "tui", "beaches" -> "beach") so plurals and
        word forms match.

     3. The query is spell-corrected against the catalogue's
        own vocabulary, then split into requirements:
        subjects, NZ places (learnt from the catalogue itself),
        colours, mood, room, style, recipient, tone, colour
        intensity, plus any other meaningful word as a keyword
        weighted by how rare it is. "no pink" / "without birds"
        become exclusions.

     4. Each artwork is scored per requirement, with stronger
        credit for evidence in the subject/title/tags than in
        long free text. Colours are compared perceptually
        (CIE Lab) against the artwork's palette, ignoring the
        white paper background.

     5. Results that lack the core subject or place asked for
        are pushed right down rather than padding the grid.
     ========================================================= */


  /* =========================================================
     TEXT
     ========================================================= */

  function normalise(value) {

    if (value === null || value === undefined) {
      return '';
    }

    var text = String(value);

    try {
      text = text.normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    } catch (e) {}

    return text
      .toLowerCase()
      .replace(/&amp;/g, ' and ')
      .replace(/&/g, ' and ')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  }


  var STEM_EXCEPTIONS = {
    kiwis: 'kiwi',
    tuis: 'tui',
    glasses: 'glass',
    species: 'species',
    series: 'series',
    news: 'news',
    canvas: 'canvas',
    atlas: 'atlas',
    lotus: 'lotus',
    iris: 'iris',
    christmas: 'christmas',
    xmas: 'xmas',
    paris: 'paris',
    always: 'always'
  };


  function stem(word) {

    if (word.length <= 3) {
      return word;
    }

    if (STEM_EXCEPTIONS.hasOwnProperty(word)) {
      return STEM_EXCEPTIONS[word];
    }

    if (/ies$/.test(word) && word.length > 4) {
      return word.slice(0, -3) + 'y';
    }

    if (/(ches|shes|xes|sses|zes)$/.test(word)) {
      return word.slice(0, -2);
    }

    if (/s$/.test(word) && !/(ss|us|is)$/.test(word)) {
      return word.slice(0, -1);
    }

    return word;

  }


  function tokenise(value) {

    var clean = normalise(value);

    if (!clean) {
      return [];
    }

    return clean.split(' ').map(stem);

  }


  var phraseCache = {};

  function stemPhrase(value) {

    var key = String(value);

    if (phraseCache.hasOwnProperty(key)) {
      return phraseCache[key];
    }

    var result = tokenise(key).join(' ');

    phraseCache[key] = result;

    return result;

  }


  function flatten(value) {

    if (value === null || value === undefined) {
      return '';
    }

    if (Array.isArray(value)) {
      return value.join(' ');
    }

    if (typeof value === 'object') {
      return Object.keys(value)
        .map(function(key) {
          return value[key];
        })
        .join(' ');
    }

    return String(value);

  }


  /*
   * A field is stored as " token token token " so phrase
   * matching is a fast whole-word indexOf.
   */

  function fieldText(value) {

    var tokens = tokenise(flatten(value));

    return tokens.length
      ? ' ' + tokens.join(' ') + ' '
      : ' ';

  }


  function hasPhrase(text, phrase) {

    var p = stemPhrase(phrase);

    return !!p && text.indexOf(' ' + p + ' ') !== -1;

  }


  function hasAnyPhrase(text, aliases) {

    if (!text || text.length < 3) {
      return false;
    }

    for (var i = 0; i < aliases.length; i++) {
      if (hasPhrase(text, aliases[i])) {
        return true;
      }
    }

    return false;

  }


  function escapeHtml(value) {

    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  function stripHtml(html) {

    return String(html || '')
      .replace(/<(style|script)[\s\S]*?<\/\1>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&#?[a-z0-9]+;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  }


  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }


  /* =========================================================
     SUBJECTS

     Specific subjects are separate from generic families.
     "tui" is NOT just "bird". "map" is NOT just "New Zealand".
     nz:true marks native / NZ-iconic subjects.
     ========================================================= */

  var specificSubjects = [

    /* Birds */
    { key: 'tui', label: 'tui', parents: ['bird'], nz: true, aliases: ['tui'] },
    { key: 'fantail', label: 'fantail', parents: ['bird'], nz: true, aliases: ['fantail', 'piwakawaka', 'piwaiwaka'] },
    { key: 'kereru', label: 'kereru', parents: ['bird'], nz: true, aliases: ['kereru', 'wood pigeon', 'kukupa'] },
    { key: 'kotare', label: 'kingfisher', parents: ['bird'], nz: true, aliases: ['kotare', 'kingfisher'] },
    { key: 'kiwi-bird', label: 'kiwi bird', parents: ['bird'], nz: true, aliases: ['kiwi bird'] },
    { key: 'pukeko', label: 'pukeko', parents: ['bird'], nz: true, aliases: ['pukeko'] },
    { key: 'huia', label: 'huia', parents: ['bird'], nz: true, aliases: ['huia'] },
    { key: 'kea', label: 'kea', parents: ['bird'], nz: true, aliases: ['kea'] },
    { key: 'kaka', label: 'kaka', parents: ['bird'], nz: true, aliases: ['kaka'] },
    { key: 'kakapo', label: 'kakapo', parents: ['bird'], nz: true, aliases: ['kakapo'] },
    { key: 'takahe', label: 'takahe', parents: ['bird'], nz: true, aliases: ['takahe'] },
    { key: 'owl', label: 'owl', parents: ['bird'], aliases: ['owl', 'morepork', 'ruru'] },
    { key: 'penguin', label: 'penguin', parents: ['bird'], aliases: ['penguin', 'korora'] },
    { key: 'seagull', label: 'seagull', parents: ['bird'], aliases: ['seagull', 'gull', 'karoro'] },
    { key: 'heron', label: 'heron', parents: ['bird'], aliases: ['heron', 'kotuku', 'egret'] },
    { key: 'albatross', label: 'albatross', parents: ['bird'], aliases: ['albatross', 'toroa'] },
    { key: 'duck', label: 'duck', parents: ['bird'], aliases: ['duck', 'whio', 'paradise duck'] },
    { key: 'chicken', label: 'chicken', parents: ['bird'], aliases: ['chicken', 'rooster', 'hen', 'chook'] },
    { key: 'parrot', label: 'parrot', parents: ['bird'], aliases: ['parrot', 'parakeet', 'kakariki'] },
    { key: 'flamingo', label: 'flamingo', parents: ['bird'], aliases: ['flamingo'] },

    /* Land animals */
    { key: 'dog', label: 'dog', parents: ['animal'], aliases: ['dog', 'puppy', 'pup', 'doggy'] },
    { key: 'cat', label: 'cat', parents: ['animal'], aliases: ['cat', 'kitten', 'kitty'] },
    { key: 'horse', label: 'horse', parents: ['animal'], aliases: ['horse', 'pony'] },
    { key: 'cow', label: 'cow', parents: ['animal'], aliases: ['cow', 'cattle', 'bull'] },
    { key: 'sheep', label: 'sheep', parents: ['animal'], aliases: ['sheep', 'lamb'] },
    { key: 'pig', label: 'pig', parents: ['animal'], aliases: ['pig', 'piglet'] },
    { key: 'rabbit', label: 'rabbit', parents: ['animal'], aliases: ['rabbit', 'bunny', 'hare'] },
    { key: 'hedgehog', label: 'hedgehog', parents: ['animal'], aliases: ['hedgehog'] },
    { key: 'deer', label: 'deer', parents: ['animal'], aliases: ['deer', 'stag'] },
    { key: 'tuatara', label: 'tuatara', parents: ['animal'], nz: true, aliases: ['tuatara'] },
    { key: 'gecko', label: 'gecko', parents: ['animal'], aliases: ['gecko', 'lizard', 'skink'] },
    { key: 'bee', label: 'bee', parents: ['animal'], aliases: ['bee', 'bumblebee', 'honey bee'] },
    { key: 'butterfly', label: 'butterfly', parents: ['animal'], aliases: ['butterfly', 'monarch'] },

    /* Sea life */
    { key: 'whale', label: 'whale', parents: ['animal', 'sealife'], aliases: ['whale', 'orca', 'tohora'] },
    { key: 'dolphin', label: 'dolphin', parents: ['animal', 'sealife'], aliases: ['dolphin', 'hectors dolphin'] },
    { key: 'shark', label: 'shark', parents: ['animal', 'sealife'], aliases: ['shark'] },
    { key: 'fish', label: 'fish', parents: ['animal', 'sealife'], aliases: ['fish', 'snapper', 'trout', 'kahawai', 'tuna'] },
    { key: 'octopus', label: 'octopus', parents: ['animal', 'sealife'], aliases: ['octopus', 'wheke'] },
    { key: 'turtle', label: 'turtle', parents: ['animal', 'sealife'], aliases: ['turtle'] },
    { key: 'seal', label: 'seal', parents: ['animal', 'sealife'], aliases: ['seal', 'fur seal', 'sea lion'] },
    { key: 'shell', label: 'shell', parents: ['sealife'], nz: true, aliases: ['paua', 'shell', 'seashell'] },

    /* Plants */
    { key: 'pohutukawa', label: 'pohutukawa', parents: ['floral'], nz: true, aliases: ['pohutukawa', 'christmas tree'] },
    { key: 'kowhai', label: 'kowhai', parents: ['floral'], nz: true, aliases: ['kowhai'] },
    { key: 'fern', label: 'fern', parents: ['floral'], nz: true, aliases: ['fern', 'ponga', 'silver fern', 'koru'] },
    { key: 'flax', label: 'flax', parents: ['floral'], nz: true, aliases: ['flax', 'harakeke'] },
    { key: 'cabbage-tree', label: 'cabbage tree', parents: ['floral'], nz: true, aliases: ['cabbage tree', 'ti kouka'] },
    { key: 'protea', label: 'protea', parents: ['floral'], aliases: ['protea'] },
    { key: 'rose', label: 'rose', parents: ['floral'], aliases: ['rose', 'roses'] },
    { key: 'sunflower', label: 'sunflower', parents: ['floral'], aliases: ['sunflower'] },

    /* Landscape features */
    { key: 'mountain', label: 'mountain', parents: ['landscape'], aliases: ['mountain', 'maunga', 'peak'] },
    { key: 'lake', label: 'lake', parents: ['landscape'], aliases: ['lake', 'roto'] },
    { key: 'valley', label: 'valley', parents: ['landscape'], aliases: ['valley'] },
    { key: 'river', label: 'river', parents: ['landscape'], aliases: ['river', 'stream', 'awa'] },
    { key: 'waterfall', label: 'waterfall', parents: ['landscape'], aliases: ['waterfall', 'falls'] },
    { key: 'island', label: 'island', parents: ['landscape'], aliases: ['island', 'motu'] },
    { key: 'volcano', label: 'volcano', parents: ['landscape'], aliases: ['volcano', 'volcanic'] },
    { key: 'lighthouse', label: 'lighthouse', parents: ['landscape'], aliases: ['lighthouse'] },

    /* Vehicles */
    { key: 'car', label: 'car', parents: ['vehicle'], aliases: ['car', 'holden', 'kombi', 'hot rod', 'classic car'] },
    { key: 'truck', label: 'truck', parents: ['vehicle'], aliases: ['truck', 'ute', 'lorry'] },
    { key: 'train', label: 'train', parents: ['vehicle'], aliases: ['train', 'locomotive', 'railway'] },
    { key: 'boat', label: 'boat', parents: ['vehicle'], aliases: ['boat', 'yacht', 'sailboat', 'sailing', 'dinghy', 'ship', 'ferry'] },
    { key: 'tractor', label: 'tractor', parents: ['vehicle'], aliases: ['tractor'] },
    { key: 'bike', label: 'bike', parents: ['vehicle'], aliases: ['bike', 'bicycle', 'cycling', 'motorbike', 'motorcycle'] },
    { key: 'caravan', label: 'caravan', parents: ['vehicle'], aliases: ['caravan', 'campervan', 'camper'] },
    { key: 'plane', label: 'plane', parents: ['vehicle'], aliases: ['plane', 'aeroplane', 'airplane', 'aircraft'] },
    { key: 'waka', label: 'waka', parents: ['vehicle'], nz: true, aliases: ['waka', 'canoe'] },

    /* Places (more are learnt from the catalogue automatically) */
    { key: 'auckland', label: 'Auckland', parents: ['city'], nz: true, aliases: ['auckland', 'tamaki makaurau'] },
    { key: 'wellington', label: 'Wellington', parents: ['city'], nz: true, aliases: ['wellington', 'welly'] },
    { key: 'christchurch', label: 'Christchurch', parents: ['city'], nz: true, aliases: ['christchurch'] },
    { key: 'queenstown', label: 'Queenstown', parents: ['city'], nz: true, aliases: ['queenstown'] },

    /* Other distinct subjects */
    { key: 'map', label: 'map', parents: [], aliases: ['map', 'cartographic', 'cartography', 'atlas'] },
    { key: 'surf', label: 'surfing', parents: ['beach'], aliases: ['surf', 'surfer', 'surfing', 'surfboard'] },
    { key: 'tiki', label: 'tiki', parents: ['kiwiana'], nz: true, aliases: ['tiki', 'hei tiki'] },
    { key: 'bach', label: 'bach', parents: ['kiwiana'], nz: true, aliases: ['bach', 'crib', 'holiday bach'] },
    { key: 'pavlova', label: 'pavlova', parents: ['food', 'kiwiana'], nz: true, aliases: ['pavlova', 'pav'] },
    { key: 'coffee', label: 'coffee', parents: ['food'], aliases: ['coffee', 'flat white', 'espresso'] },
    { key: 'wine', label: 'wine', parents: ['food'], aliases: ['wine', 'vineyard'] },
    { key: 'beer', label: 'beer', parents: ['food'], aliases: ['beer', 'brewery'] },
    { key: 'fish-and-chips', label: 'fish and chips', parents: ['food', 'kiwiana'], nz: true, aliases: ['fish and chip', 'fish n chip', 'fush and chup'] },
    { key: 'jandal', label: 'jandals', parents: ['kiwiana'], nz: true, aliases: ['jandal'] },
    { key: 'rugby', label: 'rugby', parents: ['sport'], nz: true, aliases: ['rugby', 'all black'] },
    { key: 'cricket', label: 'cricket', parents: ['sport'], aliases: ['cricket'] },
    { key: 'golf', label: 'golf', parents: ['sport'], aliases: ['golf'] },
    { key: 'fishing', label: 'fishing', parents: ['sport'], aliases: ['fishing', 'fisherman', 'angler'] },
    { key: 'music', label: 'music', parents: [], aliases: ['music', 'guitar', 'vinyl', 'record player'] },
    { key: 'love', label: 'love', parents: [], aliases: ['love', 'heart', 'hearts'] },
    { key: 'christmas', label: 'Christmas', parents: [], aliases: ['christmas', 'xmas', 'festive'] }

  ];


  var genericSubjects = [

    { key: 'bird', label: 'birds', aliases: ['bird', 'birdlife', 'native bird', 'manu'] },
    { key: 'landscape', label: 'landscape', aliases: ['landscape', 'scenery', 'vista', 'panorama', 'countryside', 'scenic'] },
    { key: 'beach', label: 'beach/coastal', aliases: ['beach', 'coast', 'coastal', 'ocean', 'sea', 'seaside', 'shore', 'marine', 'bay', 'cove', 'harbour', 'harbor', 'moana'] },
    { key: 'floral', label: 'floral', aliases: ['flower', 'floral', 'botanical', 'plant', 'blossom', 'bloom', 'foliage', 'leaf', 'leaves'] },
    { key: 'city', label: 'city/urban', aliases: ['city', 'cityscape', 'urban', 'skyline'] },
    { key: 'animal', label: 'animals', aliases: ['animal', 'wildlife', 'creature'] },
    { key: 'sealife', label: 'sea life', aliases: ['sea life', 'sea creature', 'marine life', 'underwater', 'ocean life'] },
    { key: 'vehicle', label: 'vehicles', aliases: ['vehicle', 'transport', 'van', 'bus'] },
    { key: 'food', label: 'food & drink', aliases: ['food', 'drink', 'kitchen art', 'cafe'] },
    { key: 'sport', label: 'sport', aliases: ['sport', 'sporty', 'sports'] },
    { key: 'kiwiana', label: 'kiwiana', aliases: ['kiwiana', 'classic kiwiana', 'kiwi icon', 'kiwi classic'] },
    { key: 'people', label: 'people', aliases: ['people', 'person', 'figure', 'portrait', 'family'] }

  ];


  var NZ_ALIASES = [
    'new zealand', 'nz', 'aotearoa', 'kiwiana', 'kiwi'
  ];


  var locations = [
    { key: 'nz', label: 'New Zealand', aliases: NZ_ALIASES }
  ];


  /*
   * Words that, following "kiwi", mean "New Zealand"
   * rather than the bird: "kiwi dad", "kiwi summer".
   */

  var KIWI_NZ_CONTEXT = {};

  [
    'dad', 'mum', 'mom', 'father', 'mother', 'nana', 'grandma', 'granny',
    'grandad', 'granddad', 'grandpa', 'koro', 'family', 'kid', 'gift',
    'present', 'home', 'house', 'bach', 'style', 'art', 'artist', 'made',
    'design', 'summer', 'christmas', 'xmas', 'icon', 'iconic', 'classic',
    'culture', 'slang', 'humour', 'humor', 'theme', 'themed', 'souvenir',
    'friend', 'mate', 'bloke', 'expat', 'abroad', 'overseas', 'holiday',
    'life', 'pride', 'spirit', 'thing', 'print', 'poster', 'wall', 'kitchen',
    'nostalgia', 'nostalgic', 'retro', 'vintage', 'birthday', 'couple',
    'wedding', 'man', 'woman', 'guy', 'girl', 'boy', 'son', 'daughter',
    'brother', 'sister', 'uncle', 'aunt', 'teacher', 'boss', 'colleague',
    'and', 'or', 'for', 'with', 'in', 'living', 'abroad'
  ].forEach(function(word) {
    KIWI_NZ_CONTEXT[word] = true;
  });


  /* =========================================================
     COLOURS (reference colours are compared in CIE Lab)
     ========================================================= */

  var colours = [

    { key: 'blue', label: 'blue', kind: 'chromatic', related: ['teal', 'turquoise', 'aqua'],
      aliases: ['blue', 'navy', 'cobalt', 'azure', 'sky blue', 'indigo', 'denim', 'sapphire'],
      refs: ['#2D64AA', '#1B2F5E', '#6FA8DC', '#3C78D8'] },

    { key: 'teal', label: 'teal', kind: 'chromatic', related: ['blue', 'green'],
      aliases: ['teal', 'turquoise', 'aqua', 'cyan', 'aquamarine', 'petrol'],
      refs: ['#1E827D', '#087186', '#40C1C0', '#2BA8A0'] },

    { key: 'green', label: 'green', kind: 'chromatic', related: ['teal', 'olive'],
      aliases: ['green', 'emerald', 'olive', 'mint', 'sage', 'forest green', 'lime', 'khaki', 'pounamu'],
      refs: ['#3C8C50', '#6B8E23', '#98C9A3', '#2E5E3E', '#8DB580'] },

    { key: 'red', label: 'red', kind: 'chromatic', related: ['pink', 'orange'],
      aliases: ['red', 'crimson', 'scarlet', 'burgundy', 'maroon', 'cherry', 'wine red'],
      refs: ['#BE2D2D', '#8B1E2B', '#D9443A'] },

    { key: 'orange', label: 'orange', kind: 'chromatic', related: ['red', 'yellow'],
      aliases: ['orange', 'amber', 'rust', 'terracotta', 'coral', 'peach', 'apricot', 'tangerine'],
      refs: ['#DC6923', '#E8742C', '#F4A26A', '#F2955E'] },

    { key: 'yellow', label: 'yellow/gold', kind: 'chromatic', related: ['orange'],
      aliases: ['yellow', 'gold', 'golden', 'mustard', 'lemon', 'ochre', 'sunshine'],
      refs: ['#DCB42D', '#F2D649', '#C9A227', '#E8C468'] },

    { key: 'pink', label: 'pink', kind: 'chromatic', related: ['red', 'purple'],
      aliases: ['pink', 'rose pink', 'magenta', 'blush', 'fuchsia', 'hot pink', 'dusty pink'],
      refs: ['#D25A91', '#F2B6C8', '#C2185B', '#E8A0B4'] },

    { key: 'purple', label: 'purple', kind: 'chromatic', related: ['pink', 'blue'],
      aliases: ['purple', 'violet', 'lilac', 'lavender', 'mauve', 'plum'],
      refs: ['#7D4BA5', '#B39DDB', '#5B2A6E'] },

    { key: 'brown', label: 'brown/earthy', kind: 'chromatic', related: ['orange', 'beige'],
      aliases: ['brown', 'tan', 'chocolate', 'earthy', 'earth tone', 'sepia', 'caramel', 'beige', 'taupe'],
      refs: ['#7B5134', '#B08B63', '#D2B48C', '#5C4033'] },

    { key: 'black', label: 'black', kind: 'black', related: ['grey', 'charcoal'],
      aliases: ['black', 'charcoal', 'ebony', 'jet black'], refs: [] },

    { key: 'grey', label: 'grey', kind: 'grey', related: ['silver', 'black', 'white'],
      aliases: ['grey', 'gray', 'silver', 'slate'], refs: [] },

    { key: 'white', label: 'white', kind: 'white', related: ['cream', 'ivory'],
      aliases: ['white', 'cream', 'ivory', 'off white'], refs: [] }

  ];


  var MONOCHROME_ALIASES = [
    'black and white', 'black white', 'monochrome', 'monochromatic',
    'b and w', 'greyscale', 'grayscale'
  ];


  var intensities = [

    { key: 'colourful', label: 'colourful', want: 'high',
      aliases: ['colourful', 'colorful', 'vibrant', 'bright', 'bright colour', 'bright color',
        'bold colour', 'bold color', 'rainbow', 'multicoloured', 'multicolored',
        'multi coloured', 'multi colored', 'vivid', 'punchy', 'saturated', 'pop of colour',
        'pop of color', 'lots of colour', 'lots of color'] },

    { key: 'muted', label: 'muted/soft colours', want: 'low',
      aliases: ['muted', 'subtle', 'soft colour', 'soft color', 'pastel', 'neutral', 'understated',
        'desaturated', 'washed out', 'low key', 'minimal colour', 'minimal color', 'tonal'] }

  ];


  var tones = [

    { key: 'dark', label: 'dark tones', want: 'dark',
      aliases: ['dark', 'moody', 'night', 'nighttime', 'night time', 'evening', 'nocturnal', 'midnight'] },

    { key: 'light', label: 'light tones', want: 'light',
      aliases: ['light', 'pale', 'airy', 'light and airy', 'fresh', 'pastel'] }

  ];


  /* =========================================================
     ENVIRONMENT / ROOMS / MOOD / STYLE / RECIPIENT
     ========================================================= */

  var environments = [

    { key: 'coastal', label: 'coastal',
      aliases: ['coastal', 'coast', 'beach', 'ocean', 'sea', 'seaside', 'shore', 'marine', 'harbour', 'harbor', 'bay'] },

    { key: 'alpine', label: 'alpine/mountain',
      aliases: ['alpine', 'mountain', 'snow', 'snowy', 'ski', 'skiing', 'winter'] },

    { key: 'rural', label: 'rural',
      aliases: ['rural', 'countryside', 'farm', 'farmland', 'country', 'paddock', 'farming'] },

    { key: 'urban', label: 'urban',
      aliases: ['urban', 'city', 'town', 'street', 'cityscape'] },

    { key: 'nature', label: 'nature/trees',
      aliases: ['nature', 'natural', 'forest', 'bush', 'native bush', 'outdoors', 'wild', 'tree',
        'woodland', 'rainforest', 'ngahere', 'garden'] }

  ];


  var rooms = [

    { key: 'living', label: 'living room', aliases: ['living room', 'lounge', 'family room', 'living area', 'sitting room'] },
    { key: 'bedroom', label: 'bedroom', aliases: ['bedroom', 'master bedroom', 'guest room', 'spare room'] },
    { key: 'dining', label: 'dining room', aliases: ['dining room', 'dining'] },
    { key: 'kitchen', label: 'kitchen', aliases: ['kitchen'] },
    { key: 'bathroom', label: 'bathroom', aliases: ['bathroom', 'toilet', 'loo', 'powder room'] },
    { key: 'office', label: 'office', aliases: ['office', 'study', 'workspace', 'home office', 'work from home'] },
    { key: 'nursery', label: 'kids/nursery', aliases: ['nursery', 'kids room', 'childrens room', 'children room', 'baby room', 'playroom', 'kid room'] },
    { key: 'hallway', label: 'hallway', aliases: ['hallway', 'hall', 'entryway', 'entry', 'entrance', 'stairwell'] },
    { key: 'beach-house', label: 'beach house', aliases: ['beach house', 'beach home', 'bach', 'crib', 'holiday home', 'coastal home', 'holiday house', 'beach shack'] }

  ];


  var moods = [

    { key: 'calm', label: 'calm', aliases: ['calm', 'peaceful', 'relaxed', 'relaxing', 'serene', 'quiet', 'tranquil', 'restful', 'soothing', 'zen', 'chill'] },
    { key: 'happy', label: 'happy/uplifting', aliases: ['happy', 'cheerful', 'uplifting', 'joyful', 'joy', 'sunny', 'optimistic', 'feel good'] },
    { key: 'playful', label: 'playful/fun', aliases: ['playful', 'fun', 'funny', 'quirky', 'humorous', 'humour', 'humor', 'cheeky', 'cute', 'whimsical', 'silly', 'witty', 'pun'] },
    { key: 'bold', label: 'bold', aliases: ['bold', 'dramatic', 'energetic', 'strong', 'striking', 'statement'] },
    { key: 'romantic', label: 'romantic', aliases: ['romantic', 'romance'] },
    { key: 'nostalgic', label: 'nostalgic/vintage', aliases: ['nostalgic', 'nostalgia', 'retro', 'vintage', 'old school', 'classic kiwiana'] },
    { key: 'warm', label: 'warm/cosy', aliases: ['warm', 'cosy', 'cozy', 'homely', 'inviting'] }

  ];


  var styles = [

    { key: 'modern', label: 'modern', aliases: ['modern', 'contemporary', 'scandi', 'scandinavian', 'mid century'] },
    { key: 'graphic', label: 'graphic/stylised', aliases: ['graphic', 'stylised', 'stylized', 'geometric'] },
    { key: 'abstract', label: 'abstract', aliases: ['abstract'] },
    { key: 'minimal', label: 'minimal', aliases: ['minimal', 'minimalist', 'simple', 'clean'] },
    { key: 'illustrative', label: 'illustrative', aliases: ['illustrative', 'illustration', 'illustrated', 'drawing', 'hand drawn'] },
    { key: 'vintage', label: 'vintage', aliases: ['vintage', 'retro', 'old fashioned'] },
    { key: 'photographic', label: 'photographic', aliases: ['photographic', 'photo', 'photography', 'realistic'] },
    { key: 'typographic', label: 'typography', aliases: ['typography', 'typographic', 'quote', 'word', 'text', 'lettering', 'slogan', 'saying'] },
    { key: 'painterly', label: 'painterly', aliases: ['painterly', 'painting', 'watercolour', 'watercolor', 'oil painting', 'acrylic'] },
    { key: 'pop', label: 'pop art', aliases: ['pop art'] }

  ];


  var recipients = [

    { key: 'dad', label: 'dad', aliases: ['dad', 'father', 'fathers day', 'papa', 'husband'] },
    { key: 'mum', label: 'mum', aliases: ['mum', 'mom', 'mother', 'mothers day', 'mama', 'wife'] },
    { key: 'grandparent', label: 'grandparent', aliases: ['nana', 'grandma', 'granny', 'grandad', 'granddad', 'grandpa', 'grandparent', 'koro', 'kuia'] },
    { key: 'gift', label: 'gift', aliases: ['gift', 'present', 'birthday', 'housewarming', 'house warming', 'farewell', 'thank you', 'leaving'] },
    { key: 'kids', label: 'kids', aliases: ['kids', 'kid', 'children', 'child', 'baby', 'toddler', 'boy', 'girl'] },
    { key: 'couple', label: 'couple/wedding', aliases: ['couple', 'wedding', 'newlyweds', 'anniversary', 'engagement'] },
    { key: 'expat', label: 'kiwi abroad', aliases: ['expat', 'overseas', 'abroad', 'homesick', 'moving overseas', 'living overseas'] }

  ];


  /* =========================================================
     STOP WORDS (compared after stemming)
     ========================================================= */

  var STOP = {};

  [
    'i', 'im', 'ive', 'id', 'want', 'wanted', 'wanting', 'something', 'anything',
    'some', 'a', 'an', 'the', 'for', 'my', 'our', 'with', 'and', 'or', 'in', 'on', 'to',
    'of', 'at', 'by', 'from', 'into', 'about', 'around', 'please', 'preferably',
    'ideally', 'maybe', 'perhaps', 'possibly', 'looking', 'look', 'looks', 'find', 'me',
    'print', 'prints', 'art', 'artwork', 'artworks', 'kind', 'type', 'would', 'like',
    'likes', 'can', 'could', 'you', 'have', 'has', 'had', 'got', 'get', 'is', 'are', 'was',
    'be', 'it', 'its', 'that', 'this', 'these', 'those', 'one', 'ones', 'need', 'needs',
    'buy', 'buying', 'shop', 'which', 'what', 'who', 'whos', 'show', 'showing', 'depicting',
    'featuring', 'feature', 'features', 'themed', 'theme', 'inspired', 'feel', 'feeling',
    'vibe', 'vibes', 'based', 'piece', 'pieces', 'image', 'images', 'picture', 'pictures',
    'poster', 'posters', 'wall', 'walls', 'framed', 'frame', 'frames', 'unframed', 'size',
    'big', 'large', 'small', 'little', 'nice', 'beautiful', 'lovely', 'cool', 'good',
    'great', 'best', 'really', 'very', 'quite', 'so', 'too', 'much', 'more', 'most',
    'lots', 'lot', 'bit', 'all', 'any', 'just', 'only', 'even', 'other', 'others',
    'similar', 'etc', 'thing', 'things', 'stuff', 'kinda', 'sort', 'sorts', 'go', 'goes',
    'going', 'over', 'above', 'his', 'her', 'their', 'him', 'them', 'she', 'he', 'they',
    'we', 'us', 'your', 'also', 'colour', 'colours', 'color', 'colors', 'coloured',
    'colored', 'tone', 'tones', 'toned', 'room', 'rooms', 'space', 'home', 'house',
    'new', 'style', 'styled', 'decor', 'decoration', 'idea', 'ideas', 'option',
    'options', 'suit', 'suits', 'suitable', 'match', 'matches', 'matching', 'go with',
    'goes with', 'will', 'should', 'love', 'loves', 'lover', 'mainly', 'mostly', 'lot',
    'design', 'designs', 'gift', 'if', 'possible', 'than', 'then', 'there', 'here', 'where',
    'when', 'how', 'why', 'not', 'no', 'without', 'except', 'dont', 'do', 'does'
  ].forEach(function(word) {
    STOP[stem(normalise(word))] = true;
  });

  /* "love" is a real subject in this catalogue, so it is not a stop word. */
  delete STOP.love;


  var PLACE_IGNORE = {};

  [
    'new zealand', 'nz', 'aotearoa', 'north island', 'south island', 'north', 'south',
    'east', 'west', 'beach', 'bay', 'coast', 'lake', 'island', 'mountain', 'river',
    'harbour', 'city', 'town', 'central', 'upper', 'lower', 'the', 'point', 'cape',
    'general', 'various', 'none', 'n a', 'na', 'yes', 'no', 'true', 'false'
  ].forEach(function(word) {
    PLACE_IGNORE[stemPhrase(word)] = true;
  });


  var NZ_EMPTY_VALUES = {
    no: true, none: true, na: true, 'n a': true, 'false': true, '0': true,
    general: true, unknown: true, 'not applicable': true
  };


  var PLACE_GENERIC_WORDS = {
    lake: true, bay: true, beach: true, mount: true, mt: true, island: true,
    river: true, harbour: true, point: true, cape: true, port: true, the: true,
    north: true, south: true, east: true, west: true, upper: true, lower: true
  };


  /* =========================================================
     DERIVED CONCEPT LOOKUPS
     ========================================================= */

  var familyAliases = {};

  specificSubjects.forEach(function(concept) {

    (concept.parents || []).forEach(function(parent) {
      familyAliases[parent] =
        (familyAliases[parent] || []).concat(concept.aliases);
    });

  });


  var NZ_NATIVE_TERMS = ['native', 'maori', 'koru', 'kiwiana', 'aotearoa'];

  specificSubjects.forEach(function(concept) {
    if (concept.nz) {
      NZ_NATIVE_TERMS = NZ_NATIVE_TERMS.concat(concept.aliases);
    }
  });


  var ALL_ALIAS_GROUPS = [
    specificSubjects, genericSubjects, locations, colours, intensities, tones,
    environments, rooms, moods, styles, recipients
  ];


  /* =========================================================
     COLOUR SCIENCE
     ========================================================= */

  function parseHex(hex) {

    if (!hex) {
      return null;
    }

    var value = String(hex).replace('#', '').trim();

    if (value.length === 3) {
      value =
        value[0] + value[0] +
        value[1] + value[1] +
        value[2] + value[2];
    }

    if (!/^[0-9a-fA-F]{6}$/.test(value)) {
      return null;
    }

    var number = parseInt(value, 16);

    return [
      (number >> 16) & 255,
      (number >> 8) & 255,
      number & 255
    ];

  }


  function toLinear(channel) {

    var c = channel / 255;

    return c <= 0.04045
      ? c / 12.92
      : Math.pow((c + 0.055) / 1.055, 2.4);

  }


  function rgbToLab(rgb) {

    var r = toLinear(rgb[0]);
    var g = toLinear(rgb[1]);
    var b = toLinear(rgb[2]);

    var x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    var y = (r * 0.2126 + g * 0.7152 + b * 0.0722);
    var z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;

    function f(t) {
      return t > 0.008856
        ? Math.pow(t, 1 / 3)
        : (7.787 * t) + (16 / 116);
    }

    var fx = f(x);
    var fy = f(y);
    var fz = f(z);

    return [
      (116 * fy) - 16,
      500 * (fx - fy),
      200 * (fy - fz)
    ];

  }


  function deltaE(a, b) {

    var dl = a[0] - b[0];
    var da = a[1] - b[1];
    var db = a[2] - b[2];

    return Math.sqrt(dl * dl + da * da + db * db);

  }


  colours.forEach(function(concept) {
    concept.refLabs = concept.refs
      .map(parseHex)
      .filter(Boolean)
      .map(rgbToLab);
  });


  function buildPalette(value) {

    var strings = [];

    if (Array.isArray(value)) {
      strings = value.map(String);
    } else if (value) {
      strings = String(value).match(/#[0-9a-fA-F]{3,6}\b/g) || [];
    }

    return strings
      .map(parseHex)
      .filter(Boolean)
      .map(function(rgb) {

        var lab = rgbToLab(rgb);
        var chroma = Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]);
        var hue = (Math.atan2(lab[2], lab[1]) * 180 / Math.PI + 360) % 360;

        return {
          lab: lab,
          L: lab[0],
          C: chroma,
          H: hue,
          /* white / off-white paper background */
          paper: lab[0] > 88 && chroma < 10
        };

      });

  }


  function deriveIntensity(item, palette) {

    var label = normalise(item.color_intensity);

    if (/high|vibrant|bright|strong/.test(label)) return 'high';
    if (/medium|moderate|mid/.test(label)) return 'medium';
    if (/low|muted|subtle|soft/.test(label)) return 'low';

    var maxChroma = 0;
    var vivid = 0;

    palette.forEach(function(entry) {
      maxChroma = Math.max(maxChroma, entry.C);
      if (entry.C >= 30) vivid++;
    });

    if (maxChroma > 60 && vivid >= 2) return 'high';
    if (maxChroma > 35) return 'medium';

    return 'low';

  }


  function countHueFamilies(palette) {

    var buckets = {};

    palette.forEach(function(entry) {
      if (entry.C >= 25) {
        buckets[Math.floor(entry.H / 45)] = true;
      }
    });

    return Object.keys(buckets).length;

  }


  /* =========================================================
     INDEX
     ========================================================= */

  var FIELD_NAMES = [
    'title', 'subject', 'secondary', 'nz', 'environment', 'style',
    'mood', 'rooms', 'colors', 'tags', 'description', 'search'
  ];

  var SUBJECT_FIELDS = ['title', 'subject', 'secondary', 'nz', 'tags'];


  function buildIndex(rawRecords, productMap, productsComplete) {

    var records = [];
    var df = {};
    var dfSubject = {};
    var vocab = {};
    var places = {};

    /*
     * Products live in Shopify but not yet in the visual
     * catalogue (e.g. newly added prints) are still searchable
     * by title, tags and description.
     */

    var allRecords = rawRecords.slice();

    if (productMap) {

      var catalogueHandles = {};

      rawRecords.forEach(function(item) {
        if (item && item.handle) catalogueHandles[item.handle] = true;
      });

      Object.keys(productMap).forEach(function(handle) {

        if (catalogueHandles[handle]) return;

        var product = productMap[handle];

        allRecords.push({
          handle: handle,
          title: product.title,
          image: product.image
        });

      });

    }

    allRecords.forEach(function(item) {

      if (!item) return;

      var handle = item.handle || '';

      var product =
        productMap && handle
          ? productMap[handle] || null
          : null;

      /*
       * When the live collection feed loaded completely, a
       * catalogue record that isn't in it is unpublished or
       * removed — skip it so we never show a dead link.
       */

      if (productsComplete && productMap && !product) {
        return;
      }

      var tags =
        product ? product.tags : (item.tags || '');

      var description =
        product
          ? product.description
          : (item.description || stripHtml(item.body_html || ''));

      var rec = {
        item: item,
        handle: handle,
        title: item.title || (product && product.title) || '',
        image: item.image || (product && product.image) || '',
        f: {}
      };

      rec.f.title = fieldText(rec.title);
      rec.f.subject = fieldText(item.subject);
      rec.f.secondary = fieldText(item.secondary);
      rec.f.nz = fieldText(item.nz);
      rec.f.environment = fieldText(item.environment);
      rec.f.style = fieldText(item.style);
      rec.f.mood = fieldText(item.mood);
      rec.f.rooms = fieldText(item.rooms);
      rec.f.colors = fieldText(item.colors);
      /*
       * Shape tags ("portrait", "landscape", "square") say how the
       * print is orientated. They're used for orientation only, so a
       * "landscape" shape tag doesn't make a print count as scenery.
       */

      var tagShape = orientationFromTags(tags);

      rec.f.tags = fieldText(tagShape.otherTags);
      rec.f.description = fieldText(description);
      rec.f.search = fieldText(item.search);

      var nzPhrase = stemPhrase(item.nz || '');
      rec.isNz = !!nzPhrase && !NZ_EMPTY_VALUES[nzPhrase];

      rec.tagOrientation = tagShape.orientation;
      rec.catalogueOrientation = readOrientation(item.orientation);

      rec.palette = buildPalette(item.color_hex);
      rec.intensity = deriveIntensity(item, rec.palette);
      rec.hueFamilies = countHueFamilies(rec.palette);

      var lightnessTotal = 0;
      var darkCount = 0;

      rec.palette.forEach(function(entry) {
        lightnessTotal += entry.L;
        if (entry.L < 35) darkCount++;
      });

      rec.meanL = rec.palette.length ? lightnessTotal / rec.palette.length : 70;
      rec.darkFraction = rec.palette.length ? darkCount / rec.palette.length : 0;

      /* Document frequencies (for keyword rarity) */

      var seen = {};
      var seenSubject = {};

      FIELD_NAMES.forEach(function(name) {

        var tokens = rec.f[name].trim();

        if (!tokens) return;

        tokens.split(' ').forEach(function(token) {

          if (!seen[token]) {
            seen[token] = true;
            df[token] = (df[token] || 0) + 1;
          }

          if (name !== 'description') {
            vocab[token] = (vocab[token] || 0) + 1;
          }

          if (SUBJECT_FIELDS.indexOf(name) !== -1 && !seenSubject[token]) {
            seenSubject[token] = true;
            dfSubject[token] = (dfSubject[token] || 0) + 1;
          }

        });

      });

      /* Learn NZ place names from the catalogue's nz field */

      String(item.nz || '')
        .split(/[,\/;|]| and /)
        .forEach(function(raw) {

          var label = raw.trim();
          var phrase = stemPhrase(label);

          if (!phrase || phrase.length < 4 || PLACE_IGNORE[phrase]) {
            return;
          }

          if (!places[phrase]) {
            places[phrase] = { phrase: phrase, label: label };
          }

          /* "Lake Tekapo" is also findable as "Tekapo" */

          var core = phrase
            .split(' ')
            .filter(function(token) {
              return !PLACE_GENERIC_WORDS[token];
            })
            .join(' ');

          if (
            core &&
            core !== phrase &&
            core.length >= 4 &&
            !PLACE_IGNORE[core] &&
            !places[core]
          ) {
            places[core] = { phrase: core, label: label };
          }

        });

      records.push(rec);

    });


    /* Concept vocabulary is valid spelling too */

    ALL_ALIAS_GROUPS.forEach(function(group) {
      group.forEach(function(concept) {
        concept.aliases.forEach(function(alias) {
          stemPhrase(alias).split(' ').forEach(function(token) {
            if (token) vocab[token] = (vocab[token] || 0) + 1;
          });
        });
      });
    });

    MONOCHROME_ALIASES.forEach(function(alias) {
      stemPhrase(alias).split(' ').forEach(function(token) {
        if (token) vocab[token] = (vocab[token] || 0) + 1;
      });
    });


    var placeList = Object.keys(places)
      .map(function(key) {
        return places[key];
      })
      .sort(function(a, b) {
        return b.phrase.length - a.phrase.length;
      });


    /*
     * Orientation: Shopify shape tags win. The catalogue file's value
     * is only trusted if it varies — when every print says the same
     * thing (e.g. all "square", taken from square product photos) it
     * tells us nothing.
     */

    var catalogueShapes = {};

    records.forEach(function(rec) {
      if (rec.catalogueOrientation) catalogueShapes[rec.catalogueOrientation] = true;
    });

    var trustCatalogueShape = Object.keys(catalogueShapes).length > 1;

    records.forEach(function(rec) {
      rec.orientation =
        rec.tagOrientation ||
        (trustCatalogueShape ? rec.catalogueOrientation : '');
    });


    var N = Math.max(records.length, 1);

    return {
      records: records,
      N: N,
      df: df,
      dfSubject: dfSubject,
      vocab: vocab,
      vocabList: Object.keys(vocab),
      places: placeList,
      maxIdf: Math.log(1 + (N + 0.5) / 0.5)
    };

  }


  /* =========================================================
     SPELLING
     ========================================================= */

  function editDistance(a, b, max) {

    if (Math.abs(a.length - b.length) > max) {
      return max + 1;
    }

    var previous2 = null;
    var previous = [];

    for (var j = 0; j <= b.length; j++) {
      previous[j] = j;
    }

    for (var i = 1; i <= a.length; i++) {

      var current = [i];
      var rowMin = i;

      for (var k = 1; k <= b.length; k++) {

        var cost = a[i - 1] === b[k - 1] ? 0 : 1;

        var value = Math.min(
          previous[k] + 1,
          current[k - 1] + 1,
          previous[k - 1] + cost
        );

        if (
          i > 1 && k > 1 &&
          a[i - 1] === b[k - 2] &&
          a[i - 2] === b[k - 1]
        ) {
          value = Math.min(value, previous2[k - 2] + 1);
        }

        current[k] = value;

        if (value < rowMin) rowMin = value;

      }

      if (rowMin > max) {
        return max + 1;
      }

      previous2 = previous;
      previous = current;

    }

    return previous[b.length];

  }


  function correctSpelling(clean, index) {

    if (!clean) return clean;

    return clean
      .split(' ')
      .map(function(word) {

        var stemmed = stem(word);

        if (
          word.length < 4 ||
          /\d/.test(word) ||
          STOP[stemmed] ||
          index.vocab[stemmed] ||
          index.vocab[word]
        ) {
          return word;
        }

        var max = word.length >= 8 ? 2 : 1;
        var best = null;
        var bestDistance = max + 1;
        var bestFrequency = 0;

        for (var i = 0; i < index.vocabList.length; i++) {

          var candidate = index.vocabList[i];

          if (candidate.length < 3 || candidate[0] !== stemmed[0]) continue;

          /* Short words: substitutions / swaps only */
          if (stemmed.length <= 4 && candidate.length !== stemmed.length) continue;

          if (Math.abs(candidate.length - stemmed.length) > max) continue;

          var distance = editDistance(stemmed, candidate, max);

          if (
            distance < bestDistance ||
            (distance === bestDistance && index.vocab[candidate] > bestFrequency)
          ) {
            best = candidate;
            bestDistance = distance;
            bestFrequency = index.vocab[candidate];
          }

        }

        return best && bestDistance <= max ? best : word;

      })
      .join(' ');

  }


  /* =========================================================
     QUERY PARSER
     ========================================================= */

  var NEGATORS = {
    no: true, not: true, without: true, except: true, avoid: true, avoiding: true,
    minus: true, nothing: true, dont: true, never: true, exclude: true, excluding: true,
    nope: true
  };

  var NEGATION_FILLER = {
    too: true, any: true, a: true, an: true, the: true, very: true, so: true,
    overly: true, want: true, wanting: true, include: true, including: true,
    more: true, much: true, like: true, really: true, that: true, it: true,
    being: true, be: true, is: true, are: true, anything: true, something: true
  };

  var NEGATION_BREAK = {
    and: true, or: true, but: true, for: true, in: true, with: true, please: true,
    which: true, just: true, i: true, we: true, preferably: true, ideally: true,
    maybe: true, perhaps: true
  };


  function splitNegations(clean) {

    var words = clean.split(' ');
    var positive = [];
    var negative = [];

    for (var i = 0; i < words.length; i++) {

      var word = words[i];

      /* "but not" / "anything but" */
      if (
        NEGATORS[word] ||
        (word === 'but' && words[i + 1] === 'not')
      ) {

        if (word === 'but') i++;

        var taken = 0;
        var j = i + 1;

        while (j < words.length && taken < 3) {

          var next = words[j];

          if (NEGATION_BREAK[next] || NEGATORS[next]) break;

          if (!NEGATION_FILLER[next]) {
            negative.push(next);
            taken++;
          }

          j++;

        }

        if (taken) {
          negative.push('|');
          i = j - 1;
        }

        continue;

      }

      positive.push(word);

    }

    return {
      positive: positive.join(' '),
      negative: negative.join(' ').split('|').map(function(part) {
        return part.trim();
      }).filter(Boolean)
    };

  }


  function parseConcepts(text, index) {

    var stemmed = ' ' + stemPhrase(text) + ' ';
    var requirements = [];
    var consumed = {};

    function consume(phrase) {
      phrase.split(' ').forEach(function(token) {
        if (token) consumed[token] = true;
      });
    }

    function find(aliases, source) {

      source = source || stemmed;

      var best = '';
      var bestPos = -1;

      aliases.forEach(function(alias) {

        var p = stemPhrase(alias);

        if (!p) return;

        var pos = source.indexOf(' ' + p + ' ');

        if (pos !== -1 && p.length > best.length) {
          best = p;
          bestPos = pos;
        }

      });

      return best ? { alias: best, pos: bestPos } : null;

    }

    function strengthAt(pos) {

      var before = stemmed.slice(Math.max(0, pos - 30), pos + 1);

      if (/\b(maybe|perhap|possibly|optional|optionally|bonu)\b/.test(before)) return 0.55;
      if (/\b(preferably|ideally|prefer|preferred)\b/.test(before)) return 0.8;
      if (/\b(must|definitely|essential|has to|need to)\b/.test(before)) return 1.25;

      return 1;

    }

    function add(category, concept, hit, extra) {

      var requirement = {
        category: category,
        key: concept.key,
        label: concept.label,
        aliases: concept.aliases,
        strength: hit ? strengthAt(hit.pos) : 1
      };

      if (extra) {
        Object.keys(extra).forEach(function(key) {
          requirement[key] = extra[key];
        });
      }

      requirements.push(requirement);

      if (hit) consume(hit.alias);

      return requirement;

    }

    function has(category, key) {
      return requirements.some(function(r) {
        return r.category === category && r.key === key;
      });
    }


    /* --- Black & white --- */

    var mono = find(MONOCHROME_ALIASES);

    if (mono) {
      add('intensity', intensities[1], mono, { label: 'black & white', want: 'low' });
      add('colour', colours[9], null, { strength: 0.8, kind: 'black', refLabs: [] });
      consume(mono.alias);
    }


    /* --- Rooms first, so "beach house" isn't read as a beach subject --- */

    var subjectSource = stemmed;

    rooms.forEach(function(concept) {

      var hit = find(concept.aliases);

      if (!hit) return;

      add('room', concept, hit);

      subjectSource = subjectSource.replace(' ' + hit.alias + ' ', ' ');

      /*
       * "bach" is both a place to hang art and a subject:
       * prints that depict a bach should beat generic coastal
       * art (soft, so other matches still show).
       */

      if (hit.alias === 'bach' || hit.alias === 'crib') {
        var bachConcept = specificSubjects.filter(function(c) {
          return c.key === 'bach';
        })[0];
        add('subject', bachConcept, hit, {
          exact: true,
          parents: bachConcept.parents,
          strength: Math.min(0.7, strengthAt(hit.pos))
        });
      }

    });


    /* --- NZ places learnt from the catalogue --- */

    var placePhrases = [];

    index.places.forEach(function(place) {

      if (stemmed.indexOf(' ' + place.phrase + ' ') === -1) return;

      var tokens = place.phrase.split(' ');

      if (tokens.every(function(token) { return consumed[token]; })) return;

      requirements.push({
        category: 'place',
        key: 'place:' + place.phrase,
        label: place.label,
        aliases: [place.phrase],
        strength: strengthAt(stemmed.indexOf(' ' + place.phrase + ' '))
      });

      placePhrases.push(place.phrase);
      consume(place.phrase);

    });


    /* --- Specific subjects --- */

    var specificParents = {};

    specificSubjects.forEach(function(concept) {

      var hit = find(concept.aliases, subjectSource);

      if (!hit) return;

      /* Already captured as a catalogue place */
      if (placePhrases.some(function(p) {
        return (' ' + p + ' ').indexOf(' ' + hit.alias + ' ') !== -1;
      })) {
        return;
      }

      add('subject', concept, hit, {
        exact: true,
        parents: concept.parents || []
      });

      (concept.parents || []).forEach(function(parent) {
        specificParents[parent] = true;
      });

    });


    /* --- Generic subjects (skipped when a specific one covers it) --- */

    genericSubjects.forEach(function(concept) {

      if (specificParents[concept.key]) return;

      var hit = find(concept.aliases, subjectSource);

      if (!hit) return;

      add('subject', concept, hit, { exact: false });

    });


    /* --- New Zealand --- */

    var nzHit = find(locations[0].aliases);

    if (nzHit) {
      add('location', locations[0], nzHit);
    }


    /* --- Environment --- */

    environments.forEach(function(concept) {

      var hit = find(concept.aliases, subjectSource);

      if (hit) add('environment', concept, hit);

    });


    /* --- Colour --- */

    colours.forEach(function(concept) {

      if (mono && (concept.key === 'black' || concept.key === 'white')) return;

      var hit = find(concept.aliases);

      if (hit) {
        add('colour', concept, hit, {
          kind: concept.kind,
          refLabs: concept.refLabs,
          related: concept.related
        });
      }

    });


    /* --- Colour intensity & tone --- */

    intensities.forEach(function(concept) {

      if (mono && concept.key === 'muted') return;

      var hit = find(concept.aliases);

      if (hit) add('intensity', concept, hit, { want: concept.want });

    });

    tones.forEach(function(concept) {

      var hit = find(concept.aliases);

      if (hit) add('tone', concept, hit, { want: concept.want });

    });


    /* --- Mood / style / recipient --- */

    moods.forEach(function(concept) {
      var hit = find(concept.aliases);
      if (hit) add('mood', concept, hit);
    });

    styles.forEach(function(concept) {
      var hit = find(concept.aliases);
      if (hit) add('style', concept, hit);
    });

    recipients.forEach(function(concept) {
      var hit = find(concept.aliases);
      if (hit) add('recipient', concept, hit);
    });


    /* --- Inferences --- */

    if (has('room', 'beach-house') && !has('environment', 'coastal')) {
      add('environment', environments[0], null, { strength: 0.5, inferred: true });
    }

    if (
      /\b(in|among|under|on|around|beside|amongst)( a| the)? (tree|forest|woodland|bush)\b/.test(stemmed) &&
      !has('environment', 'nature')
    ) {
      add('environment', environments[4], null);
    }

    /* In a NZ store, "native" means NZ native */
    if (/ native /.test(stemmed) && !has('location', 'nz')) {
      add('location', locations[0], null, { strength: 0.6 });
    }

    if (has('recipient', 'expat') && !has('location', 'nz')) {
      add('location', locations[0], null, { strength: 0.9 });
    }


    /* --- Keywords: any other meaningful word the catalogue knows --- */

    var seenKeyword = {};

    stemmed.trim().split(' ').forEach(function(token) {

      if (
        !token ||
        token.length < 3 ||
        /^\d+$/.test(token) ||
        STOP[token] ||
        consumed[token] ||
        seenKeyword[token] ||
        !index.df[token]
      ) {
        return;
      }

      seenKeyword[token] = true;

      var docFreq = index.df[token];
      var idf = Math.log(1 + (index.N - docFreq + 0.5) / (docFreq + 0.5));
      var rarity = clamp(idf / index.maxIdf);

      var subjectLike =
        !!index.dfSubject[token] &&
        docFreq <= index.N * 0.3;

      requirements.push({
        category: 'keyword',
        key: 'kw:' + token,
        label: token,
        token: token,
        aliases: [token],
        weight: (0.08 + 0.30 * rarity) * (subjectLike ? 1.3 : 1),
        subjectLike: subjectLike,
        strength: strengthAt(stemmed.indexOf(' ' + token + ' '))
      });

    });


    return requirements;

  }


  /* =========================================================
     ORIENTATION
     A stated print shape ("landscape orientated", "portrait",
     "horizontal", "square") is ranked ahead of everything else.
     ========================================================= */

  function readOrientation(value) {

    var text = normalise(value);

    if (!text) return '';
    if (/landscape|horizontal|panoram|wide/.test(text)) return 'landscape';
    if (/portrait|vertical|tall/.test(text)) return 'portrait';
    if (/square/.test(text)) return 'square';

    return '';

  }


  var SHAPE_TAGS = {
    'landscape': 'landscape', 'landscape orientation': 'landscape', 'landscape format': 'landscape',
    'horizontal': 'landscape', 'wide': 'landscape', 'panoramic': 'landscape', 'panorama': 'landscape',
    'portrait': 'portrait', 'portrait orientation': 'portrait', 'portrait format': 'portrait',
    'vertical': 'portrait', 'tall': 'portrait',
    'square': 'square', 'square format': 'square', 'square orientation': 'square',
    'orientation landscape': 'landscape', 'orientation portrait': 'portrait', 'orientation square': 'square'
  };


  function orientationFromTags(tags) {

    var list = Array.isArray(tags)
      ? tags
      : String(tags || '').split(',');

    var orientation = '';
    var other = [];

    list.forEach(function(tag) {

      var key = normalise(tag);
      var shape = SHAPE_TAGS[key];

      if (shape) {
        if (!orientation) orientation = shape;
      } else if (key) {
        other.push(tag);
      }

    });

    return { orientation: orientation, otherTags: other.join(', ') };

  }


  var ORIENT_CUE =
    '(?:orientated|oriented|orientation|orientations|orient|format|formatted|shape|shaped|layout|ratio|aspect|way round|way around)';

  var ORIENTATION_RULES = [

    /* "landscape orientated", "orientation landscape", "in landscape format" */
    { want: 'landscape', re: new RegExp('\\blandscape\\s+' + ORIENT_CUE + '\\b', 'g') },
    { want: 'landscape', re: new RegExp('\\b' + ORIENT_CUE + '\\s+(?:is\\s+|in\\s+)?landscape\\b', 'g') },
    { want: 'landscape', re: /\b(?:horizontal|horizontally|widescreen|wide format|wide print|wide prints|long and thin)\b/g },

    { want: 'portrait', re: new RegExp('\\bportrait\\s+' + ORIENT_CUE + '\\b', 'g') },
    { want: 'portrait', re: new RegExp('\\b' + ORIENT_CUE + '\\s+(?:is\\s+|in\\s+)?portrait\\b', 'g') },
    { want: 'portrait', re: /\b(?:vertical|vertically|tall and narrow|tall format)\b/g },

    /* bare "portrait" is the print shape, unless it's "a portrait of ..." */
    { want: 'portrait', re: /\bportraits?\b(?!\s+of\b)/g },

    { want: 'square', re: new RegExp('\\bsquare\\s+' + ORIENT_CUE + '\\b', 'g') },
    { want: 'square', re: /\bsquare(?:\s+(?:prints?|art|artworks?|pieces?|ones?|posters?))?\b/g }

  ];


  /*
   * Finds an orientation request, removes those words so they
   * aren't also read as subjects ("landscape" scenery,
   * "portrait" people), and notes a negated one ("not portrait").
   */

  function extractOrientation(clean) {

    var want = '';
    var avoid = '';

    ORIENTATION_RULES.forEach(function(rule) {

      clean = clean.replace(rule.re, function(match, offset) {

        var before = clean.slice(Math.max(0, offset - 20), offset);

        if (/\b(?:no|not|without|avoid|except|dont|never)\s+(?:(?:a|an|in|too|any)\s+)?$/.test(before)) {
          if (!avoid) avoid = rule.want;
        } else if (!want) {
          want = rule.want;
        }

        return ' ';

      });

    });

    if (want && avoid === want) avoid = '';

    return {
      text: clean.replace(/\b(?:no|not|without|avoid|except|dont|never)\s+(?=(?:and|or|but|$))/g, ' ').replace(/\s+/g, ' ').trim(),
      want: want,
      avoid: avoid
    };

  }


  function parseQuery(query, index) {

    var clean = normalise(query);

    var orientation = extractOrientation(clean);

    clean = correctSpelling(orientation.text, index);


    /*
     * "kiwi" on its own (or "cute kiwi") is the bird.
     * "kiwi dad", "kiwi summer", "kiwi art" mean New Zealand.
     */

    /* Words for matching against print names (before the kiwi rewrite) */

    var titleTokens = [];

    stemPhrase(splitNegations(clean).positive).split(' ').forEach(function(token) {
      if (token && !STOP[token] && titleTokens.indexOf(token) === -1) {
        titleTokens.push(token);
      }
    });

    var kiwiInferred = false;

    clean = clean.replace(
      /\bkiwis?\b(?! birds?\b)(?: ([a-z0-9]+))?/g,
      function(match, next) {

        if (next && KIWI_NZ_CONTEXT[stem(next)]) {
          return match;
        }

        kiwiInferred = true;

        return 'kiwi bird' + (next ? ' ' + next : '');

      }
    );


    var parts = splitNegations(clean);

    var requirements = parseConcepts(parts.positive, index);

    if (kiwiInferred) {
      requirements.forEach(function(r) {
        if (r.key === 'kiwi-bird') r.strength = Math.min(r.strength, 0.85);
      });
    }

    var negatives = [];

    parts.negative.forEach(function(text) {
      negatives = negatives.concat(parseConcepts(text, index));
    });


    var hasExact = requirements.some(function(r) {
      return r.category === 'subject' && r.exact && r.strength >= 0.8;
    });

    var hasPlace = requirements.some(function(r) {
      return r.category === 'place' && r.strength >= 0.8;
    });

    var hasGeneric = requirements.some(function(r) {
      return r.category === 'subject' && !r.exact && r.strength >= 0.8;
    });

    var keywordProtect =
      !hasExact && !hasPlace && !hasGeneric &&
      requirements.some(function(r) {
        return r.category === 'keyword' && r.subjectLike && r.strength >= 0.8;
      });


    return {
      text: clean,
      requirements: requirements,
      negatives: negatives,
      hasExact: hasExact,
      hasPlace: hasPlace,
      hasGeneric: hasGeneric,
      keywordProtect: keywordProtect,
      orientation: orientation.want,
      avoidOrientation: orientation.avoid,
      titleTokens: titleTokens,
      titlePhrase: titleTokens.join(' ')
    };

  }


  /* =========================================================
     SATISFACTION — how well one artwork meets one requirement
     ========================================================= */

  function tiered(rec, aliases, tiers) {

    for (var i = 0; i < tiers.length; i++) {
      if (hasAnyPhrase(rec.f[tiers[i][0]], aliases)) {
        return tiers[i][1];
      }
    }

    return 0;

  }


  function familyMatch(rec, family) {

    var aliases = familyAliases[family];

    if (!aliases) return false;

    return (
      hasAnyPhrase(rec.f.subject, aliases) ||
      hasAnyPhrase(rec.f.title, aliases) ||
      hasAnyPhrase(rec.f.secondary, aliases) ||
      hasAnyPhrase(rec.f.tags, aliases)
    );

  }


  function colourSatisfaction(rec, requirement) {

    var textHit = hasAnyPhrase(rec.f.colors, requirement.aliases);

    var relatedHit =
      !textHit &&
      requirement.related &&
      hasAnyPhrase(rec.f.colors, requirement.related);

    var tagHit =
      !textHit &&
      hasAnyPhrase(rec.f.tags, requirement.aliases);

    var palette = 0;

    rec.palette.forEach(function(entry) {

      var similarity = 0;

      if (requirement.kind === 'chromatic') {

        /* Ignore the paper background and near-greys */
        if (entry.paper || entry.C < 10) return;

        var best = Infinity;

        requirement.refLabs.forEach(function(ref) {
          best = Math.min(best, deltaE(entry.lab, ref));
        });

        similarity = 1 - best / 42;

        if (entry.C < 20) similarity *= 0.75;

      } else if (requirement.kind === 'black') {

        if (entry.C < 20) {
          similarity =
            entry.L < 20 ? 1 :
            entry.L < 30 ? 0.8 :
            entry.L < 40 ? 0.45 : 0;
        }

      } else if (requirement.kind === 'grey') {

        if (!entry.paper && entry.C < 10 && entry.L >= 30 && entry.L <= 85) {
          similarity = 0.85;
        }

      } else if (requirement.kind === 'white') {

        if (entry.L > 88 && entry.C < 12) {
          similarity = 0.55;
        }

      }

      palette = Math.max(palette, similarity);

    });

    palette = clamp(palette);

    if (textHit && palette >= 0.55) return 1;
    if (textHit) return Math.max(0.9, palette);

    var score = palette * 0.92;

    if (relatedHit) score = Math.max(score, 0.45);
    if (tagHit) score = Math.max(score, 0.8);

    if (score === 0 && hasAnyPhrase(rec.f.search, requirement.aliases)) {
      score = 0.45;
    }

    return clamp(score);

  }


  function satisfaction(rec, r) {

    var f = rec.f;

    switch (r.category) {

      case 'subject': {

        if (r.exact) {

          var exactScore = tiered(rec, r.aliases, [
            ['subject', 1],
            ['title', 0.98],
            ['secondary', 0.82],
            ['tags', 0.8],
            ['nz', 0.75],
            ['search', 0.6],
            ['description', 0.42]
          ]);

          if (exactScore) return exactScore;

          /*
           * A sibling in the same family is only a weak fallback:
           * a tui search can still show another bird, but it can
           * never outrank an actual tui.
           */

          if ((r.parents || []).some(function(parent) {
            return familyMatch(rec, parent);
          })) {
            return 0.12;
          }

          return 0;

        }

        var genericScore = tiered(rec, r.aliases, [
          ['subject', 1],
          ['title', 0.9],
          ['secondary', 0.78],
          ['tags', 0.75],
          ['search', 0.55],
          ['description', 0.4]
        ]);

        /* "bird" is satisfied by a tui, "animal" by a dog, etc. */
        if (genericScore < 0.9 && familyMatch(rec, r.key)) {
          genericScore = 0.9;
        }

        return genericScore;

      }

      case 'place':
        return tiered(rec, r.aliases, [
          ['nz', 1],
          ['title', 0.95],
          ['subject', 0.88],
          ['tags', 0.85],
          ['secondary', 0.75],
          ['search', 0.7],
          ['description', 0.5]
        ]);

      case 'location': {

        /* Explicitly about New Zealand as a whole beats a single NZ place */
        if (
          hasAnyPhrase(f.subject, NZ_ALIASES) ||
          hasAnyPhrase(f.title, NZ_ALIASES) ||
          hasAnyPhrase(f.nz, NZ_ALIASES)
        ) {
          return 1;
        }

        if (rec.isNz) return 0.94;

        var nzScore = tiered(rec, NZ_ALIASES, [
          ['title', 0.95],
          ['subject', 0.95],
          ['tags', 0.9],
          ['secondary', 0.85],
          ['search', 0.8],
          ['description', 0.6]
        ]);

        if (nzScore >= 0.85) return nzScore;

        var nativeScore = tiered(rec, NZ_NATIVE_TERMS, [
          ['subject', 0.88],
          ['title', 0.88],
          ['secondary', 0.85],
          ['tags', 0.85],
          ['search', 0.7]
        ]);

        return Math.max(nzScore, nativeScore);

      }

      case 'colour':
        return colourSatisfaction(rec, r);

      case 'environment':
        return tiered(rec, r.aliases, [
          ['environment', 1],
          ['subject', 0.8],
          ['secondary', 0.72],
          ['title', 0.72],
          ['tags', 0.72],
          ['search', 0.5],
          ['description', 0.4]
        ]);

      case 'room': {

        var roomScore = tiered(rec, r.aliases, [
          ['rooms', 1],
          ['tags', 0.8],
          ['title', 0.8],
          ['secondary', 0.75],
          ['subject', 0.75],
          ['search', 0.5],
          ['description', 0.45]
        ]);

        if (
          !roomScore &&
          r.key === 'beach-house' &&
          (
            hasAnyPhrase(f.environment, environments[0].aliases) ||
            hasAnyPhrase(f.subject, genericSubjects[2].aliases)
          )
        ) {
          roomScore = 0.5;
        }

        if (
          !roomScore &&
          r.key === 'nursery' &&
          hasAnyPhrase(f.mood, moods[2].aliases)
        ) {
          roomScore = 0.35;
        }

        return roomScore;

      }

      case 'mood':
        return tiered(rec, r.aliases, [
          ['mood', 1],
          ['tags', 0.8],
          ['title', 0.6],
          ['search', 0.6],
          ['description', 0.45]
        ]);

      case 'style':
        return tiered(rec, r.aliases, [
          ['style', 1],
          ['tags', 0.8],
          ['search', 0.6],
          ['description', 0.45]
        ]);

      case 'recipient': {

        var recipientScore = tiered(rec, r.aliases, [
          ['tags', 0.9],
          ['title', 0.75],
          ['subject', 0.7],
          ['search', 0.7],
          ['description', 0.6]
        ]);

        if (
          !recipientScore &&
          r.key === 'kids' &&
          (
            hasAnyPhrase(f.rooms, rooms[6].aliases) ||
            hasAnyPhrase(f.mood, moods[2].aliases)
          )
        ) {
          recipientScore = 0.55;
        }

        if (!recipientScore && r.key === 'expat' && rec.isNz) {
          recipientScore = 0.6;
        }

        return recipientScore;

      }

      case 'intensity': {

        var level = rec.intensity;
        var value;

        if (r.want === 'high') {
          value = level === 'high' ? 1 : level === 'medium' ? 0.6 : 0.15;
          if (rec.hueFamilies >= 3) value += 0.1;
        } else {
          value = level === 'low' ? 1 : level === 'medium' ? 0.6 : 0.1;
        }

        return clamp(value);

      }

      case 'tone': {

        if (r.want === 'dark') {

          var dark = clamp(rec.darkFraction * 2);

          if (hasAnyPhrase(f.colors, ['black', 'dark', 'navy', 'charcoal'])) {
            dark = Math.max(dark, 0.6);
          }

          if (hasAnyPhrase(f.subject, ['night']) || hasAnyPhrase(f.title, ['night'])) {
            dark = Math.max(dark, 0.85);
          }

          return dark;

        }

        return rec.meanL >= 85 ? 1 : rec.meanL >= 72 ? 0.65 : 0.2;

      }

      case 'keyword':
        return keywordSatisfaction(rec, r.token);

    }

    return 0;

  }


  var KEYWORD_FIELDS = [
    ['title', 1],
    ['subject', 1],
    ['nz', 0.95],
    ['secondary', 0.85],
    ['tags', 0.85],
    ['style', 0.6],
    ['mood', 0.6],
    ['environment', 0.6],
    ['description', 0.55],
    ['search', 0.5],
    ['rooms', 0.4],
    ['colors', 0.4]
  ];


  function keywordSatisfaction(rec, token) {

    var best = 0;

    for (var i = 0; i < KEYWORD_FIELDS.length; i++) {

      var text = rec.f[KEYWORD_FIELDS[i][0]];
      var weight = KEYWORD_FIELDS[i][1];

      if (weight <= best) continue;

      if (text.indexOf(' ' + token + ' ') !== -1) {
        best = weight;
      } else if (token.length >= 5 && text.indexOf(' ' + token) !== -1) {
        /* prefix: "botanic" -> "botanical" */
        best = Math.max(best, weight * 0.75);
      }

    }

    return best;

  }


  /* =========================================================
     WEIGHTS
     ========================================================= */

  var weights = {
    subject: 0.50,
    place: 0.40,
    location: 0.15,
    colour: 0.13,
    environment: 0.10,
    tone: 0.06,
    intensity: 0.06,
    mood: 0.05,
    style: 0.04,
    room: 0.04,
    recipient: 0.03
  };


  function weightOf(requirement) {

    var base =
      requirement.category === 'keyword'
        ? requirement.weight
        : (weights[requirement.category] || 0.03);

    return base * (requirement.strength || 1);

  }


  /* =========================================================
     SCORE
     ========================================================= */

  function scoreArtwork(rec, parsed) {

    var requirements = parsed.requirements;

    var total = 0;
    var sum = 0;
    var matches = [];
    var missing = 0;
    var protectScore = 0;
    var genericScore = 0;
    var keywordProtectScore = 0;
    var subjectScore = 0;
    var satisfied = 0;
    var colourHits = 0;
    var colourCount = 0;
    var keys = {};

    requirements.forEach(function(r) {

      var sat = satisfaction(rec, r);
      var weight = weightOf(r);

      total += weight;
      sum += weight * sat;

      keys[r.key] = sat;

      if (sat >= 0.6) satisfied++;

      if (r.category === 'subject' || r.category === 'place') {
        subjectScore = Math.max(subjectScore, sat);
      }

      if ((r.category === 'subject' && r.exact) || r.category === 'place') {
        protectScore = Math.max(protectScore, sat);
      }

      if (r.category === 'subject' && !r.exact) {
        genericScore = Math.max(genericScore, sat);
      }

      if (r.category === 'keyword' && r.subjectLike) {
        keywordProtectScore = Math.max(keywordProtectScore, sat);
        subjectScore = Math.max(subjectScore, sat * 0.9);
      }

      if (r.category === 'colour') {
        colourCount++;
        if (sat >= 0.6) colourHits++;
      }

      if (sat >= 0.5) {
        matches.push({ label: r.label, score: sat, category: r.category });
      }

      if (
        sat < 0.2 &&
        (r.strength || 1) >= 0.8 &&
        !r.inferred &&
        r.category !== 'subject' &&
        r.category !== 'place' &&
        r.category !== 'keyword'
      ) {
        missing++;
      }

    });

    var score = total > 0 ? sum / total : 0;


    /* --- Relationship bonuses --- */

    if (keys.map >= 0.7 && keys.nz >= 0.8) score += 0.06;

    if (keys.tui >= 0.7 && keys.nature >= 0.5) score += 0.05;

    if (colourCount >= 2) {
      if (colourHits === colourCount) score += 0.05;
      else if (colourHits > 0) score += 0.015;
    }

    if (requirements.length >= 2 && satisfied === requirements.length) {
      score += 0.04;
    }


    /* --- Core subject / place protection --- */

    if (parsed.hasExact || parsed.hasPlace) {

      if (protectScore < 0.12) score *= 0.08;
      else if (protectScore < 0.3) score *= 0.22;
      else if (protectScore < 0.45) score *= 0.5;

    } else if (parsed.hasGeneric) {

      if (genericScore < 0.2) score *= 0.3;
      else if (genericScore < 0.45) score *= 0.65;

    } else if (parsed.keywordProtect) {

      if (keywordProtectScore < 0.3) score *= 0.35;

    }


    /* --- Missing several secondary requirements --- */

    if (missing) {
      score *= Math.max(0.6, 1 - 0.1 * missing);
    }


    /*
     * --- Print name ---
     * Every meaningful search word in the title ("blue bach" ->
     * "Blue Bach") means the shopper is very likely naming
     * this print, so it goes to the top whatever else applies.
     */

    var titleTokens = parsed.titleTokens || [];
    var titleHits = 0;

    titleTokens.forEach(function(token) {
      if (rec.f.title.indexOf(' ' + token + ' ') !== -1) titleHits++;
    });

    var titleFull = titleTokens.length > 0 && titleHits === titleTokens.length;

    if (titleFull) {

      var phrase =
        titleTokens.length >= 2 &&
        rec.f.title.indexOf(' ' + parsed.titlePhrase + ' ') !== -1;

      score = Math.max(score, 0.9) + 0.15 + (phrase ? 0.1 : 0);

      /* multi-word names: the more of the title the query covers, the better */
      score += 0.05 * (titleHits / Math.max(1, rec.f.title.trim().split(' ').length));

    } else if (titleTokens.length >= 2 && titleHits / titleTokens.length >= 0.5) {

      score += 0.2 * (titleHits / titleTokens.length);

    }


    /* --- Exclusions ("no pink", "without birds") --- */

    parsed.negatives.forEach(function(r) {

      var sat = satisfaction(rec, r);

      if (sat >= 0.6) score *= 0.12;
      else if (sat >= 0.4) score *= 0.5;

    });


    score = Math.max(score, 0);

    return {
      score: score,
      subjectScore: subjectScore,
      protectScore: protectScore,
      titleFull: titleFull,
      orientationMatch: orientationRank(rec, parsed),
      matches: matches
    };

  }


  /* 2 = the shape asked for, 1 = unknown shape, 0 = the wrong shape */

  function orientationRank(rec, parsed) {

    if (parsed.orientation) {
      if (rec.orientation === parsed.orientation) return 2;
      return rec.orientation ? 0 : 1;
    }

    if (parsed.avoidOrientation) {
      if (!rec.orientation) return 1;
      return rec.orientation === parsed.avoidOrientation ? 0 : 2;
    }

    return 0;

  }


  /* =========================================================
     EXPLANATION
     ========================================================= */

  function createReason(result) {

    var labels = [];

    result.matches
      .slice()
      .sort(function(a, b) {
        return b.score - a.score;
      })
      .forEach(function(match) {
        if (labels.indexOf(match.label) === -1 && labels.length < 3) {
          labels.push(match.label);
        }
      });

    if (!labels.length) {
      return 'Related artwork.';
    }

    if (labels.length === 1) {
      return 'Matches your ' + labels[0] + ' request.';
    }

    if (labels.length === 2) {
      return 'Matches your ' + labels[0] + ' and ' + labels[1] + ' request.';
    }

    return 'Matches your ' + labels[0] + ', ' + labels[1] + ' and ' + labels[2] + ' request.';

  }


  function sizedImage(url) {

    if (!url) return '';

    if (
      /cdn\.shopify\.com|\/cdn\/shop\//.test(url) &&
      !/[?&]width=/.test(url)
    ) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=700';
    }

    return url;

  }


  /* =========================================================
     LOAD DATA
     ========================================================= */

  async function fetchCatalogue() {

    var response = await fetch(catalogueUrl, {
      method: 'GET',
      cache: 'force-cache',
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Catalogue could not be loaded');
    }

    var data = await response.json();

    if (!data || !Array.isArray(data.records)) {
      throw new Error('Invalid catalogue');
    }

    return data.records.filter(function(item) {

      if (item && item.product_type) {
        return normalise(item.product_type) === 'art print';
      }

      return !!item;

    });

  }


  var PRODUCT_CACHE_KEY = 'aaf-products-v1-' + collectionHandle;
  var PRODUCT_CACHE_MS = 6 * 60 * 60 * 1000;


  function simplifyProduct(product) {

    return {
      handle: product.handle,
      title: product.title || '',
      type: product.product_type || '',
      tags: Array.isArray(product.tags)
        ? product.tags.join(', ')
        : (product.tags || ''),
      description: stripHtml(product.body_html).slice(0, 1500),
      image:
        product.images && product.images.length
          ? (product.images[0].src || '')
          : ''
    };

  }


  async function fetchProductPage(page) {

    var response = await fetch(
      '/collections/' + collectionHandle + '/products.json?limit=250&page=' + page,
      { headers: { 'Accept': 'application/json' } }
    );

    if (!response.ok) {
      throw new Error('Collection page ' + page + ' failed');
    }

    var data = await response.json();

    return data.products || [];

  }


  /*
   * The live collection feed supplies tags and descriptions,
   * and tells us which products are currently published.
   */

  async function fetchCollectionProducts() {

    try {

      var cached = window.sessionStorage.getItem(PRODUCT_CACHE_KEY);

      if (cached) {

        var parsedCache = JSON.parse(cached);

        if (
          parsedCache &&
          parsedCache.products &&
          Date.now() - parsedCache.time < PRODUCT_CACHE_MS
        ) {
          return parsedCache;
        }

      }

    } catch (e) {}

    var products = [];
    var complete = false;

    /* Fetch the first four pages together, then continue if needed */

    var firstPages = await Promise.all(
      [1, 2, 3, 4].map(function(page) {
        return fetchProductPage(page);
      })
    );

    for (var i = 0; i < firstPages.length; i++) {

      firstPages[i].forEach(function(product) {
        products.push(simplifyProduct(product));
      });

      if (firstPages[i].length < 250) {
        complete = true;
        break;
      }

    }

    for (var page = 5; !complete && page <= 12; page++) {

      var list = await fetchProductPage(page);

      list.forEach(function(product) {
        products.push(simplifyProduct(product));
      });

      if (list.length < 250) complete = true;

    }

    var result = {
      time: Date.now(),
      complete: complete,
      products: products
    };

    if (complete) {
      try {
        window.sessionStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(result));
      } catch (e) {}
    }

    return result;

  }


  var cataloguePromise = null;
  var productsPromise = null;
  var indexState = null;


  function getCatalogue() {

    if (!cataloguePromise) {
      cataloguePromise = fetchCatalogue().catch(function(error) {
        cataloguePromise = null;
        throw error;
      });
    }

    return cataloguePromise;

  }


  function getProducts() {

    if (!productsPromise) {
      productsPromise = fetchCollectionProducts().catch(function(error) {
        console.warn('Art Finder: collection feed unavailable', error);
        return null;
      });
    }

    return productsPromise;

  }


  function withTimeout(promise, ms) {

    return Promise.race([
      promise,
      new Promise(function(resolve) {
        setTimeout(function() {
          resolve(undefined);
        }, ms);
      })
    ]);

  }


  async function loadIndex() {

    var productsPending = getProducts();

    if (indexState && indexState.withProducts) {
      return indexState.index;
    }

    var records = await getCatalogue();

    /*
     * Don't hold the first search hostage to the tag feed:
     * wait briefly, and if it arrives later the index is
     * rebuilt on the next search.
     */

    var products = await withTimeout(productsPending, indexState ? 0 : 3500);

    if (indexState && !products) {
      return indexState.index;
    }

    var map = null;
    var complete = false;

    if (products && products.products && products.products.length) {

      map = {};

      products.products.forEach(function(product) {
        if (product.handle) map[product.handle] = product;
      });

      complete =
        !!products.complete &&
        products.products.length >= records.length * 0.5;

    }

    indexState = {
      index: buildIndex(records, map, complete),
      withProducts: !!map
    };

    return indexState.index;

  }


  function warmUp() {
    loadIndex().catch(function() {});
  }


  /* =========================================================
     SEARCH
     ========================================================= */

  function runSearch(index, query, defaultReason) {

    var parsed = parseQuery(query, index);

    var orientationOnly =
      !parsed.requirements.length &&
      !parsed.titleTokens.length &&
      !!parsed.orientation;

    if (!parsed.requirements.length && !parsed.titleTokens.length && !orientationOnly) {
      return [];
    }

    var scored = index.records.map(function(rec) {
      return {
        rec: rec,
        result: scoreArtwork(rec, parsed)
      };
    });

    var byOrientation = !!(parsed.orientation || parsed.avoidOrientation);

    scored.sort(function(a, b) {

      /* A stated print shape comes before everything else */
      if (byOrientation && b.result.orientationMatch !== a.result.orientationMatch) {
        return b.result.orientationMatch - a.result.orientationMatch;
      }

      if (b.result.score !== a.result.score) {
        return b.result.score - a.result.score;
      }

      if (b.result.subjectScore !== a.result.subjectScore) {
        return b.result.subjectScore - a.result.subjectScore;
      }

      return String(a.rec.title).localeCompare(String(b.rec.title));

    });

    var hardProtect = parsed.hasExact || parsed.hasPlace;

    var credible = scored.filter(function(entry) {

      if (orientationOnly) {
        return entry.result.orientationMatch === 2;
      }

      if (entry.result.titleFull) {
        return true;
      }

      if (hardProtect) {
        return (
          entry.result.score >= 0.18 &&
          entry.result.protectScore >= 0.45
        );
      }

      return entry.result.score >= 0.2;

    });

    /*
     * The whole credible list is returned (best first) so
     * "Show more" can page through it.
     */

    var selected = credible.slice(0, MAX_RESULTS);

    return selected.map(function(entry) {

      var rec = entry.rec;
      var reason = createReason(entry.result);

      if (entry.result.titleFull && reason === 'Related artwork.') {
        reason = 'Matches the print name you searched for.';
      }

      if (parsed.orientation && entry.result.orientationMatch === 2) {
        var shape = parsed.orientation.charAt(0).toUpperCase() + parsed.orientation.slice(1);
        reason = reason === 'Related artwork.' || orientationOnly
          ? shape + ' print.'
          : shape + ' print. ' + reason;
      }

      return {
        title: rec.title,
        handle: rec.handle,
        url: rec.handle ? '/products/' + rec.handle : '#',
        image: sizedImage(rec.image),
        match: Math.round(Math.min(entry.result.score, 0.99) * 100),
        reason:
          reason === 'Related artwork.' && defaultReason
            ? defaultReason
            : reason,
        tags: []
      };

    });

  }


  var MAX_RESULTS = 60;


  async function searchCatalogue(query) {

    var index = await loadIndex();

    currentIndex = index;

    return runSearch(index, query);

  }


  /* =========================================================
     MORE LIKE THIS
     Compares one print with every other print on subject,
     colour palette, style, mood, setting, place and series.
     ========================================================= */

  var SIMILAR_IGNORE = {};

  [
    'new', 'zealand', 'nz', 'aotearoa', 'scene', 'general', 'interior',
    'friendly', 'illustration', 'graphic', 'varied', 'decorative', 'limited',
    'edition', 'a1', 'a2', 'a3', 'a4', 'a5', 'framed', 'unframed', 'print',
    'art', 'artwork', 'giclee', 'canvas', 'original', 'size', 'set'
  ].forEach(function(word) {
    SIMILAR_IGNORE[stem(word)] = true;
  });


  function tokenSet(text) {

    var set = {};

    text.trim().split(' ').forEach(function(token) {
      if (
        token &&
        token.length >= 3 &&
        !/^\d+$/.test(token) &&
        !STOP[token] &&
        !SIMILAR_IGNORE[token]
      ) {
        set[token] = true;
      }
    });

    return set;

  }


  function cosine(a, b) {

    var ka = Object.keys(a);
    var kb = Object.keys(b);

    if (!ka.length || !kb.length) return 0;

    var shared = 0;

    ka.forEach(function(key) {
      if (b[key]) shared++;
    });

    return shared / Math.sqrt(ka.length * kb.length);

  }


  function similarityProfile(rec) {

    if (rec._similar) return rec._similar;

    var f = rec.f;
    var subjectText = f.subject + ' ' + f.secondary + ' ' + f.title;

    var concepts = {};
    var families = {};

    specificSubjects.forEach(function(concept) {
      if (hasAnyPhrase(subjectText, concept.aliases) || hasAnyPhrase(f.tags, concept.aliases)) {
        concepts[concept.key] = true;
        (concept.parents || []).forEach(function(parent) {
          families[parent] = true;
        });
      }
    });

    genericSubjects.forEach(function(concept) {
      if (hasAnyPhrase(f.subject + ' ' + f.secondary, concept.aliases)) {
        families[concept.key] = true;
      }
    });

    rec._similar = {
      subject: tokenSet(f.subject + ' ' + f.secondary + ' ' + f.tags),
      title: tokenSet(f.title),
      series: Object.keys(tokenSet(f.title)).sort().join(' '),
      environment: tokenSet(f.environment),
      mood: tokenSet(f.mood),
      style: tokenSet(f.style),
      place: stemPhrase(rec.item.nz || ''),
      concepts: concepts,
      families: families,
      chroma: rec.palette.filter(function(entry) {
        return !entry.paper && entry.C >= 10;
      })
    };

    return rec._similar;

  }


  function paletteSimilarity(a, b) {

    if (!a.length && !b.length) return 0.9;
    if (!a.length || !b.length) return 0.25;

    function averageNearest(from, to) {
      var total = 0;
      from.forEach(function(entry) {
        var best = Infinity;
        to.forEach(function(other) {
          best = Math.min(best, deltaE(entry.lab, other.lab));
        });
        total += best;
      });
      return total / from.length;
    }

    var distance = (averageNearest(a, b) + averageNearest(b, a)) / 2;

    return clamp(1 - distance / 45);

  }


  function overlapScore(a, b) {

    var keys = Object.keys(a);

    if (!keys.length) return 0;

    for (var i = 0; i < keys.length; i++) {
      if (b[keys[i]]) return 1;
    }

    return 0;

  }


  function compareArtworks(source, other) {

    var a = similarityProfile(source);
    var b = similarityProfile(other);

    var subject = cosine(a.subject, b.subject);

    var concept =
      overlapScore(a.concepts, b.concepts) ? 1 :
      overlapScore(a.families, b.families) ? 0.5 : 0;

    /* No palette on record (e.g. a print not yet in the catalogue file) */
    var colour =
      source.palette.length && other.palette.length
        ? paletteSimilarity(a.chroma, b.chroma)
        : 0.3;
    var environment = cosine(a.environment, b.environment);
    var mood = cosine(a.mood, b.mood);
    var style = cosine(a.style, b.style);
    var title = cosine(a.title, b.title);

    var series = !!a.series && a.series === b.series;
    var samePlace = !!a.place && !NZ_EMPTY_VALUES[a.place] && a.place === b.place;

    var score =
      0.30 * subject +
      0.20 * concept +
      0.20 * colour +
      0.08 * environment +
      0.07 * mood +
      0.07 * style +
      0.04 * (source.intensity === other.intensity ? 1 : 0) +
      0.08 * title +
      (samePlace ? 0.05 : (source.isNz && other.isNz ? 0.02 : 0)) +
      (series ? 0.12 : 0);

    var parts = [];

    if (subject >= 0.45 || concept === 1) parts.push('subject');
    if (colour >= 0.65) parts.push('colours');
    if (style >= 0.6) parts.push('style');
    if (mood >= 0.5 && parts.length < 3) parts.push('mood');

    var reason;

    if (series) {
      reason = 'From the same series.';
    } else if (samePlace) {
      reason = 'Also ' + (other.item.nz || 'this place') + '.';
    } else if (parts.length === 1) {
      reason = 'Similar ' + parts[0] + '.';
    } else if (parts.length === 2) {
      reason = 'Similar ' + parts[0] + ' and ' + parts[1] + '.';
    } else if (parts.length >= 3) {
      reason = 'Similar ' + parts[0] + ', ' + parts[1] + ' and ' + parts[2] + '.';
    } else {
      reason = 'A related print you might like.';
    }

    return { score: score, reason: reason };

  }


  function findSimilar(index, handle) {

    var source = null;

    index.records.forEach(function(rec) {
      if (rec.handle === handle) source = rec;
    });

    if (!source) return null;

    var scored = [];

    index.records.forEach(function(rec) {

      if (rec === source || !rec.handle) return;

      var comparison = compareArtworks(source, rec);

      if (comparison.score >= 0.12) {
        scored.push({ rec: rec, comparison: comparison });
      }

    });

    scored.sort(function(x, y) {
      return y.comparison.score - x.comparison.score;
    });

    /* Keep good matches, but always offer at least one full page */

    var good = scored.filter(function(entry) {
      return entry.comparison.score >= 0.25;
    });

    scored = good.length >= resultCount
      ? good
      : scored.slice(0, Math.max(good.length, resultCount));

    return {
      source: source,
      cards: scored.slice(0, MAX_RESULTS).map(function(entry) {
        return {
          title: entry.rec.title,
          handle: entry.rec.handle,
          url: '/products/' + entry.rec.handle,
          image: sizedImage(entry.rec.image),
          match: Math.round(Math.min(entry.comparison.score, 0.99) * 100),
          reason: entry.comparison.reason,
          tags: []
        };
      })
    };

  }


  /* =========================================================
     API FALLBACK
     ========================================================= */

  async function searchApi(query) {

    if (!apiEndpoint) {
      return [];
    }

    var response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: query,
        limit: resultCount,
        collection: collectionHandle,
        collection_url: '/collections/art-prints',
        shop: 'glenn-jones-art.myshopify.com'
      })
    });

    if (!response.ok) {
      throw new Error('AI endpoint returned an error');
    }

    var data = await response.json();

    return data.results || data.products || data.items || [];

  }


  /* =========================================================
     SHOPIFY FALLBACK
     Used only if the visual catalogue can't be loaded: the
     same engine runs over the live collection's titles, tags
     and descriptions.
     ========================================================= */

  async function fallbackSearch(query) {

    var products = await getProducts();

    if (!products || !products.products || !products.products.length) {
      productsPromise = null;
      products = await getProducts();
    }

    if (!products || !products.products || !products.products.length) {
      throw new Error('Collection search failed');
    }

    var records = products.products.map(function(product) {
      return {
        handle: product.handle,
        title: product.title,
        image: product.image,
        tags: product.tags,
        description: product.description
      };
    });

    var index = buildIndex(records, null, false);

    currentIndex = index;

    return runSearch(
      index,
      query,
      'Related artwork from the Art Prints collection.'
    );

  }


  /* =========================================================
     RENDER
     ========================================================= */

  function updateMoreButton() {

    if (!moreWrap) return;

    moreWrap.hidden = view.shown >= view.cards.length;

  }


  /* Show the next page of cards from the current list */

  function appendCards() {

    var next = view.cards.slice(view.shown, view.shown + resultCount);

    next.forEach(function(item) {
      grid.appendChild(createCard(item));
    });

    view.shown += next.length;

    updateMoreButton();

  }


  function renderResults(items) {

    grid.innerHTML = '';

    view.cards = items || [];
    view.shown = 0;

    if (!view.cards.length) {
      updateMoreButton();
      empty.classList.add('is-visible');
      results.classList.add('is-visible');
      return;
    }

    empty.classList.remove('is-visible');

    appendCards();

    results.classList.add('is-visible');

  }


  function createCard(item) {

      var card = document.createElement('article');

      card.className = 'aaf-card';

      card.innerHTML =

        '<a class="aaf-card-image" href="' +
          escapeHtml(item.url) +
        '">' +

          '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '" loading="lazy">' +

        '</a>' +

        '<div class="aaf-card-info">' +

          '<a class="aaf-card-title" href="' +
            escapeHtml(item.url) +
          '">' +
            escapeHtml(item.title) +
          '</a>' +

          '<p class="aaf-card-reason">' +
            escapeHtml(item.reason) +
          '</p>' +

          (
            item.handle && currentIndex
              ? '<button class="aaf-similar" type="button" data-handle="' +
                  escapeHtml(item.handle) +
                '">More like this</button>'
              : ''
          ) +

        '</div>';

      return card;

  }


  /* =========================================================
     STATUS
     ========================================================= */

  function setStatus(message, loading) {

    status.classList.add('is-visible');

    if (loading) {
      status.innerHTML =
        '<span class="aaf-spinner"></span>' +
        escapeHtml(message);
    } else {
      status.textContent = message;
    }

  }


  function hideStatus() {

    status.classList.remove('is-visible');

    status.innerHTML = '';

  }


  /* =========================================================
     ANALYTICS
     ========================================================= */

  function trackSearch(query, items) {

    try {

      if (
        typeof Shopify !== 'undefined' &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {

        Shopify.analytics.publish('glenn_art_finder:search', {
          query: query,
          collection: collectionHandle,
          result_count: items ? items.length : 0,
          results: items
            ? items.slice(0, resultCount).map(function(item) {
                return item.title;
              })
            : [],
          timestamp: new Date().toISOString()
        });

      }

    } catch (error) {

      console.warn('Art Finder analytics:', error);

    }

  }


  /* =========================================================
     MAIN SEARCH
     ========================================================= */

  async function performSearch() {

    var query = input.value.trim();

    if (!query) {
      input.focus();
      return;
    }

    lastQuery = query;

    button.disabled = true;

    results.classList.remove('is-visible');
    empty.classList.remove('is-visible');

    resetView();

    setStatus('Understanding what you are looking for…', true);

    try {

      /*
       * LOCAL CATALOGUE IS PRIMARY.
       */

      var items = await searchCatalogue(query);

      /*
       * Only use the AI endpoint if the local catalogue
       * genuinely couldn't find enough, and only to fill
       * empty positions — never to replace strong matches.
       */

      if (
        items.length < Math.min(3, resultCount) &&
        apiEndpoint
      ) {

        try {

          var apiItems = await searchApi(query);

          if (apiItems && apiItems.length) {

            var existingHandles = {};

            items.forEach(function(item) {
              existingHandles[item.url] = true;
            });

            apiItems.forEach(function(item) {

              if (items.length >= resultCount) return;

              var handle = item.handle || '';

              var url =
                item.url ||
                (handle ? '/products/' + handle : '#');

              if (existingHandles[url]) return;

              items.push({
                title: item.title || '',
                url: url,
                image: sizedImage(
                  item.image ||
                  (
                    item.images && item.images.length
                      ? (item.images[0].src || item.images[0].url || '')
                      : ''
                  )
                ),
                match: 0,
                reason: 'Related artwork based on your search.',
                tags: []
              });

              existingHandles[url] = true;

            });

          }

        } catch (apiError) {

          console.warn('Optional AI endpoint unavailable:', apiError);

        }

      }

      hideStatus();

      renderResults(items);

      trackSearch(query, items);

      if (items && items.length) {
        results.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    } catch (error) {

      console.error('AI Art Finder catalogue search:', error);

      /*
       * Final fallback.
       */

      try {

        setStatus('Searching the Art Prints collection…', true);

        var fallback = await fallbackSearch(query);

        hideStatus();

        renderResults(fallback);

        trackSearch(query, fallback);

      } catch (fallbackError) {

        console.error('Art Finder fallback:', fallbackError);

        hideStatus();

        grid.innerHTML = '';

        empty.classList.add('is-visible');
        results.classList.add('is-visible');

        trackSearch(query, []);

      }

    } finally {

      button.disabled = false;

    }

  }


  /* =========================================================
     MORE LIKE THIS / SHOW MORE / BACK
     ========================================================= */

  function setHeading(text) {
    if (resultsTitle) resultsTitle.textContent = text;
  }


  function resetView() {

    view.mode = 'search';
    savedSearch = null;
    similarSource = null;

    setHeading(defaultHeading);

    if (back) back.hidden = true;

  }


  function showSimilar(handle) {

    if (!currentIndex) return;

    var similar = findSimilar(currentIndex, handle);

    if (!similar) return;

    /* Remember the original search once, so Back always returns to it */

    if (view.mode === 'search') {
      savedSearch = {
        cards: view.cards,
        shown: view.shown
      };
    }

    view.mode = 'similar';

    setHeading('More like ' + similar.source.title.replace(/\s+art print$/i, ''));

    if (back) back.hidden = !savedSearch;

    renderResults(similar.cards);

    similarSource = similar.source;

    trackEvent('glenn_art_finder:more_like_this', {
      query: lastQuery,
      source: similar.source.handle,
      source_title: similar.source.title,
      result_count: similar.cards.length,
      results: similar.cards.slice(0, resultCount).map(function(card) {
        return card.title;
      })
    });

    results.scrollIntoView({ behavior: 'smooth', block: 'start' });

  }


  function restoreSearch() {

    if (!savedSearch) return;

    var saved = savedSearch;

    resetView();

    grid.innerHTML = '';
    empty.classList.remove('is-visible');

    view.cards = saved.cards;
    view.shown = 0;

    while (view.shown < saved.shown && view.shown < view.cards.length) {
      appendCards();
    }

    updateMoreButton();

    results.scrollIntoView({ behavior: 'smooth', block: 'start' });

  }


  function trackEvent(name, data) {

    try {

      if (
        typeof Shopify !== 'undefined' &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        data.timestamp = new Date().toISOString();
        Shopify.analytics.publish(name, data);
      }

    } catch (error) {}

  }


  grid.addEventListener('click', function(event) {

    var target = event.target;

    var trigger =
      target && target.closest
        ? target.closest('.aaf-similar')
        : null;

    if (trigger) {
      event.preventDefault();
      showSimilar(trigger.getAttribute('data-handle'));
      return;
    }

    /* Which result did the shopper open? */

    var link =
      target && target.closest
        ? target.closest('.aaf-card-image, .aaf-card-title')
        : null;

    if (!link) return;

    var url = link.getAttribute('href') || '';
    var position = 0;
    var title = '';

    for (var i = 0; i < view.cards.length; i++) {
      if (view.cards[i].url === url) {
        position = i + 1;
        title = view.cards[i].title;
        break;
      }
    }

    trackEvent('glenn_art_finder:result_click', {
      query: lastQuery,
      title: title,
      url: url,
      position: position,
      mode: view.mode,
      source_title: view.mode === 'similar' && similarSource ? similarSource.title : ''
    });

  });


  if (more) {
    more.addEventListener('click', function() {
      appendCards();
      trackEvent('glenn_art_finder:show_more', {
        query: lastQuery,
        source_title: view.mode === 'similar' && similarSource ? similarSource.title : '',
        mode: view.mode,
        shown: view.shown
      });
    });
  }


  if (back) {
    back.addEventListener('click', restoreSearch);
  }


  /* =========================================================
     EVENTS
     ========================================================= */

  button.addEventListener('click', performSearch);

  input.addEventListener('keydown', function(event) {

    if (event.key === 'Enter') {
      event.preventDefault();
      performSearch();
    }

  });

  /* Start loading data as soon as the shopper shows intent */

  input.addEventListener('focus', warmUp, { once: true });
  root.addEventListener('pointerenter', warmUp, { once: true });

  examples.forEach(function(example) {

    example.addEventListener('click', function() {
      input.value = example.textContent.trim();
      performSearch();
    });

  });

  clear.addEventListener('click', function() {

    input.value = '';
    grid.innerHTML = '';

    view.cards = [];
    view.shown = 0;

    resetView();
    updateMoreButton();

    results.classList.remove('is-visible');
    empty.classList.remove('is-visible');

    hideStatus();

    input.focus();

  });

  }


  function initAll() {
    var roots = document.querySelectorAll('.ai-art-finder');
    for (var i = 0; i < roots.length; i++) {
      initArtFinder(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-initialise when the section is edited in the theme editor */
  document.addEventListener('shopify:section:load', function(event) {
    initArtFinder(event.target.querySelector('.ai-art-finder'));
  });

})();